module.exports = __webpack_public_path__ + "static/media/FM_EU_Client_Agreement_March_2025.5f910e5e.pdf";